import { useState } from "react";
import { getDailyFact, type SurpriseFact as SurpriseFactType } from "../lib/facts";

function getGIPillClass(gi: number): string {
  if (gi <= 55) return "gi-pill gi-pill--low";
  if (gi <= 69) return "gi-pill gi-pill--medium";
  return "gi-pill gi-pill--high";
}

export default function SurpriseFact() {
  const [fact] = useState<SurpriseFactType | null>(() => getDailyFact());
  const [copied, setCopied] = useState(false);

  if (!fact) return null;

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "GlycemicAI",
          text: fact.shareText,
          url: "https://tryglycemic.com",
        });
        return; // native share sheet handled it
      }
      // Fallback: copy to clipboard
      await navigator.clipboard.writeText(fact.shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      if ((err as Error).name !== "AbortError") {
        try {
          await navigator.clipboard.writeText(fact.shareText);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } catch {
          console.error("Failed to share");
        }
      }
    }
  };

  return (
    <div>
      <div className="section-label">Today</div>

      <p className="text-[15px] font-semibold text-text mb-1">{fact.title}</p>
      <p className="text-sm text-text leading-relaxed">{fact.fact}</p>

      {/* GI Comparison */}
      {fact.comparison && (
        <div className="flex items-center gap-3 mt-3 font-[family-name:--font-ui]">
          <div className="text-center">
            <span className={getGIPillClass(fact.comparison.item1.gi)}>
              GI {fact.comparison.item1.gi}
            </span>
            <p className="text-xs text-muted mt-1">{fact.comparison.item1.name}</p>
          </div>
          <span className="text-xs text-muted font-medium">vs</span>
          <div className="text-center">
            <span className={getGIPillClass(fact.comparison.item2.gi)}>
              GI {fact.comparison.item2.gi}
            </span>
            <p className="text-xs text-muted mt-1">{fact.comparison.item2.name}</p>
          </div>
        </div>
      )}

      {/* Share link */}
      <button
        onClick={handleShare}
        className="mt-3 text-xs text-muted font-[family-name:--font-ui] hover:text-text transition-colors"
      >
        {copied ? "Copied!" : "Share"}
      </button>
    </div>
  );
}
